/* ============================================================
   NDS Social Feed — Client v1.0
   Modal logic, API fetching, Facebook & Instagram renderers
   ============================================================ */
(function () {
  'use strict';

  /* ── SVG Icon Library ── */
  var ICONS = {
    heart: '<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 000-7.78z"/></svg>',
    comment: '<svg viewBox="0 0 24 24"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>',
    share: '<svg viewBox="0 0 24 24"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>',
    externalLink: '<svg viewBox="0 0 24 24"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>',
    arrowLeft: '<svg viewBox="0 0 24 24"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>',
    close: '<svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    alertCircle: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>',
    facebook: '<svg viewBox="0 0 24 24"><path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"/></svg>',
    instagram: '<svg viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>'
  };

  /* ── Main Controller ── */
  var NDSSocialFeed = {
    apiBase: '',
    cache: {},
    activeModal: null,
    activeTrigger: null,
    igDetailActive: false,
    savedScrollY: 0,

    /* — Init — */
    init: function () {
      this.refreshApiBase();
      this.bindGlobalTriggers();
      this.bindModalEvents();
      document.querySelectorAll('.nds-social-modal').forEach(function (modal) {
        modal.setAttribute('aria-hidden', 'true');
      });
    },

    /* — Re-read backend URL from any [data-nds-social-api] container on the page — */
    refreshApiBase: function () {
      var container = document.querySelector('[data-nds-social-api]');
      if (container) {
        this.apiBase = container.getAttribute('data-nds-social-api') || '';
      }
    },

    /* — Single delegated click listener that catches every social trigger —
       Works for nds-hero, nds-hero-video, and any future section that uses
       [data-social="facebook|instagram"]. Robust against late-rendered DOM. */
    bindGlobalTriggers: function () {
      if (this._delegatedBound) return;
      this._delegatedBound = true;
      var self = this;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-social]');
        if (!btn) return;
        // Ignore links to external pages — only intercept buttons / [data-social] without href
        if (btn.tagName === 'A' && btn.getAttribute('href') && btn.getAttribute('href').charAt(0) !== '#') return;
        var platform = btn.getAttribute('data-social');
        if (platform !== 'facebook' && platform !== 'instagram') return;
        e.preventDefault();
        self.openModal(platform, btn);
      });
    },

    /* Legacy alias — preserved so external code calling NDSSocialFeed.bindHeroButtons() still works. */
    bindHeroButtons: function () {
      this.bindGlobalTriggers();
    },

    /* — Bind modal close events — */
    bindModalEvents: function () {
      var self = this;
      document.querySelectorAll('.nds-social-modal').forEach(function (modal) {
        if (modal !== self.activeModal) modal.setAttribute('aria-hidden', 'true');
      });
      document.querySelectorAll('.nds-social-modal__backdrop').forEach(function (el) {
        if (el.dataset.ndsSocialModalBound) return;
        el.dataset.ndsSocialModalBound = 'true';
        el.addEventListener('click', function () { self.closeModal(); });
      });
      document.querySelectorAll('.nds-social-modal__close').forEach(function (el) {
        if (el.dataset.ndsSocialModalBound) return;
        el.dataset.ndsSocialModalBound = 'true';
        el.addEventListener('click', function () { self.closeModal(); });
      });
      if (!this._keyEventsBound) {
        this._keyEventsBound = true;
        document.addEventListener('keydown', function (e) {
          if (!self.activeModal) return;
          if (e.key === 'Escape') {
            e.preventDefault();
            self.closeModal();
          } else if (e.key === 'Tab') {
            self.trapFocus(e);
          }
        });
      }

      /* Block wheel events from reaching Lenis (on window) */
      document.querySelectorAll('.nds-social-modal__dialog').forEach(function (dialog) {
        if (dialog.dataset.ndsSocialModalBound) return;
        dialog.dataset.ndsSocialModalBound = 'true';
        dialog.setAttribute('data-lenis-prevent', '');
        dialog.addEventListener('wheel', function (e) {
          e.stopPropagation();
        }, { passive: true });
      });
    },

    /* — Open modal — */
    openModal: function (platform, trigger) {
      // Refresh apiBase in case the [data-nds-social-api] container was rendered late
      this.refreshApiBase();
      var modal = document.getElementById('nds-social-modal-' + platform);
      if (!modal) {
        console.warn('[NDS Social] Modal element #nds-social-modal-' + platform + ' not found. Make sure the section that owns the modals is enabled and the URL field is filled in.');
        return;
      }
      if (this.activeModal === modal) return;
      if (this.activeModal) this.closeModal(false);
      this.activeModal = modal;
      this.activeTrigger = trigger && typeof trigger.focus === 'function' ? trigger : document.activeElement;
      this.savedScrollY = window.scrollY;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.body.style.top = '-' + this.savedScrollY + 'px';
      document.body.classList.add('nds-social-modal-open');
      document.documentElement.classList.add('nds-social-modal-open');
      document.dispatchEvent(new CustomEvent('nds:modal:open'));
      requestAnimationFrame(function () {
        modal.classList.add('is-active');
        var close = modal.querySelector('.nds-social-modal__close');
        if (close) {
          try {
            close.focus({ preventScroll: true });
          } catch (e) {
            close.focus();
          }
        }
      });
      if (!this.cache[platform]) {
        this.fetchFeed(platform);
      }
    },

    /* — Close modal — */
    closeModal: function (restoreFocus) {
      var modal = this.activeModal;
      if (!modal) return;
      var trigger = this.activeTrigger;
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('nds-social-modal-open');
      document.documentElement.classList.remove('nds-social-modal-open');
      document.body.style.overflow = '';
      document.body.style.top = '';
      window.scrollTo(0, this.savedScrollY);
      document.dispatchEvent(new CustomEvent('nds:modal:close'));
      this.activeModal = null;
      this.activeTrigger = null;
      /* reset IG detail view if open */
      if (this.igDetailActive) {
        this.igShowGrid();
      }
      if (restoreFocus !== false && trigger && document.contains(trigger)) {
        requestAnimationFrame(function () {
          try {
            trigger.focus({ preventScroll: true });
          } catch (e) {
            trigger.focus();
          }
        });
      }
    },

    /* Keep keyboard focus inside the active sheet while it is open. */
    trapFocus: function (event) {
      var modal = this.activeModal;
      if (!modal) return;
      var focusable = Array.prototype.filter.call(
        modal.querySelectorAll('a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (element) {
          return element.getAttribute('aria-hidden') !== 'true' && (element.offsetWidth || element.offsetHeight || element.getClientRects().length);
        }
      );
      if (!focusable.length) {
        event.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },

    /* — Fetch feed from API — */
    fetchFeed: function (platform) {
      var self = this;
      var body = document.querySelector('#nds-social-modal-' + platform + ' .nds-social-modal__body');
      if (!body) return;

      body.innerHTML = this.renderSkeleton(platform);

      if (!this.apiBase) {
        body.innerHTML = this.renderEmpty('API endpoint not configured.');
        return;
      }

      var url = this.apiBase.replace(/\/$/, '') + '/api/' + platform + '/feed';

      fetch(url, { mode: 'cors' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          self.cache[platform] = data;
          if (platform === 'facebook') {
            self.renderFacebookFeed(body, data);
          } else {
            self.renderInstagramFeed(body, data);
          }
        })
        .catch(function (err) {
          console.warn('[NDS Social] Fetch error:', err);
          body.innerHTML = self.renderEmpty('Could not load feed. Please try again later.', true, platform);
          self.bindRetry(body, platform);
        });
    },

    /* — Bind retry button — */
    bindRetry: function (container, platform) {
      var self = this;
      var btn = container.querySelector('.nds-social-empty__retry');
      if (btn) {
        btn.addEventListener('click', function () {
          self.cache[platform] = null;
          self.fetchFeed(platform);
        });
      }
    },

    /* ── Facebook Renderer ── */
    renderFacebookFeed: function (container, data) {
      var posts = data.posts || [];
      var page = data.page || {};
      if (!posts.length) {
        container.innerHTML = this.renderEmpty('No posts available.');
        return;
      }
      var html = '<div class="nds-fb-feed">';
      for (var i = 0; i < posts.length; i++) {
        html += this.renderFacebookPost(posts[i], page);
      }
      html += '</div>';
      container.innerHTML = html;
      this.staggerEntrance(container.querySelectorAll('.nds-fb-post'), 80);
      this.lazyLoadImages(container);
      this.bindReadMore(container);
    },

    renderFacebookPost: function (post, page) {
      var imgHtml = '';
      if (post.full_picture) {
        imgHtml = '<div class="nds-fb-post__image-wrap">' +
          '<img class="nds-fb-post__image" data-src="' + this.escapeAttr(post.full_picture) + '" data-loaded="false" alt="" loading="lazy">' +
          '</div>';
      }
      var textHtml = '';
      if (post.message) {
        var msg = this.escapeHtml(post.message);
        textHtml = '<div class="nds-fb-post__content">' +
          '<p class="nds-fb-post__text">' + msg + '</p>' +
          (msg.length > 200 ? '<button class="nds-fb-post__read-more" type="button">Read more</button>' : '') +
          '</div>';
      }
      var likes = (post.reactions && post.reactions.summary) ? post.reactions.summary.total_count || 0 : (post.likes_count || 0);
      var comments = (post.comments && post.comments.summary) ? post.comments.summary.total_count || 0 : (post.comments_count || 0);
      var permalink = post.permalink_url || '#';

      return '<article class="nds-fb-post">' +
        '<div class="nds-fb-post__header">' +
          (page.picture ? '<img class="nds-fb-post__avatar" src="' + this.escapeAttr(page.picture) + '" alt="" loading="lazy">' : '<div class="nds-fb-post__avatar"></div>') +
          '<div class="nds-fb-post__meta">' +
            '<span class="nds-fb-post__name">' + this.escapeHtml(page.name || 'Natural Dye Store') + '</span>' +
            '<span class="nds-fb-post__date">' + this.formatDate(post.created_time) + '</span>' +
          '</div>' +
        '</div>' +
        imgHtml +
        textHtml +
        '<div class="nds-fb-post__actions">' +
          '<div class="nds-fb-post__stats">' +
            '<span class="nds-fb-post__stat nds-fb-post__stat--likes">' + ICONS.heart + ' ' + this.formatNumber(likes) + '</span>' +
            '<span class="nds-fb-post__stat">' + ICONS.comment + ' ' + this.formatNumber(comments) + '</span>' +
          '</div>' +
          '<a class="nds-fb-post__link" href="' + this.escapeAttr(permalink) + '" target="_blank" rel="noopener noreferrer">View ' + ICONS.externalLink + '</a>' +
        '</div>' +
      '</article>';
    },

    /* — Bind read-more toggles — */
    bindReadMore: function (container) {
      container.querySelectorAll('.nds-fb-post__read-more').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var text = btn.previousElementSibling;
          if (text) {
            text.classList.toggle('is-expanded');
            btn.textContent = text.classList.contains('is-expanded') ? 'Show less' : 'Read more';
          }
        });
      });
    },

    /* ── Instagram Renderer ── */
    renderInstagramFeed: function (container, data) {
      var self = this;
      var posts = data.posts || [];
      var profile = data.profile || {};
      if (!posts.length) {
        container.innerHTML = this.renderEmpty('No posts available.');
        return;
      }

      var profileHtml = '';
      if (profile.username || profile.name) {
        profileHtml = '<div class="nds-ig-profile">' +
          (profile.profile_picture_url
            ? '<img class="nds-ig-profile__avatar" src="' + this.escapeAttr(profile.profile_picture_url) + '" alt="" loading="lazy">'
            : '<div class="nds-ig-profile__avatar"></div>') +
          '<div class="nds-ig-profile__info">' +
            '<div class="nds-ig-profile__name">' + this.escapeHtml(profile.name || profile.username || '') + '</div>' +
            '<div class="nds-ig-profile__stats">' +
              (profile.media_count != null ? '<span class="nds-ig-profile__stat"><strong>' + this.formatNumber(profile.media_count) + '</strong> posts</span>' : '') +
              (profile.followers_count != null ? '<span class="nds-ig-profile__stat"><strong>' + this.formatNumber(profile.followers_count) + '</strong> followers</span>' : '') +
              (profile.follows_count != null ? '<span class="nds-ig-profile__stat"><strong>' + this.formatNumber(profile.follows_count) + '</strong> following</span>' : '') +
            '</div>' +
            (profile.biography ? '<div class="nds-ig-profile__bio">' + this.escapeHtml(profile.biography) + '</div>' : '') +
          '</div>' +
        '</div>';
      }

      var gridHtml = '<div class="nds-ig-grid" id="nds-ig-grid">';
      for (var i = 0; i < posts.length; i++) {
        var p = posts[i];
        if (p.media_type === 'VIDEO' && p.thumbnail_url) {
          var imgSrc = p.thumbnail_url;
        } else {
          var imgSrc = p.media_url || '';
        }
        var likes = p.like_count || 0;
        var comments = p.comments_count || 0;
        gridHtml += '<div class="nds-ig-item" data-index="' + i + '">' +
          '<img class="nds-ig-item__image" data-src="' + this.escapeAttr(imgSrc) + '" data-loaded="false" alt="" loading="lazy">' +
          '<div class="nds-ig-item__overlay">' +
            '<span class="nds-ig-item__stat">' + ICONS.heart + ' ' + this.formatNumber(likes) + '</span>' +
            '<span class="nds-ig-item__stat">' + ICONS.comment + ' ' + this.formatNumber(comments) + '</span>' +
          '</div>' +
        '</div>';
      }
      gridHtml += '</div>';

      var detailHtml = '<div class="nds-ig-detail" id="nds-ig-detail"></div>';

      container.innerHTML = profileHtml + gridHtml + detailHtml;
      this.staggerEntrance(container.querySelectorAll('.nds-ig-item'), 40);
      if (container.querySelector('.nds-ig-profile')) {
        container.querySelector('.nds-ig-profile').classList.add('nds-social-post-enter');
      }
      this.lazyLoadImages(container);

      /* Bind grid item clicks */
      container.querySelectorAll('.nds-ig-item').forEach(function (item) {
        item.addEventListener('click', function () {
          var idx = parseInt(item.getAttribute('data-index'), 10);
          self.igShowDetail(container, posts[idx], data);
        });
      });
    },

    /* — IG detail view — */
    igShowDetail: function (container, post, data) {
      var detail = container.querySelector('#nds-ig-detail');
      var grid = container.querySelector('#nds-ig-grid');
      var profile = container.querySelector('.nds-ig-profile');
      if (!detail || !grid) return;

      var imgSrc = (post.media_type === 'VIDEO' && post.thumbnail_url) ? post.thumbnail_url : (post.media_url || '');
      var likes = post.like_count || 0;
      var comments = post.comments_count || 0;

      detail.innerHTML =
        '<button class="nds-ig-detail__back" type="button">' + ICONS.arrowLeft + ' Back to grid</button>' +
        '<img class="nds-ig-detail__image" src="' + this.escapeAttr(imgSrc) + '" alt="" loading="lazy">' +
        '<div class="nds-ig-detail__info">' +
          '<div class="nds-ig-detail__stats">' +
            '<span class="nds-ig-detail__stat">' + ICONS.heart + ' ' + this.formatNumber(likes) + '</span>' +
            '<span class="nds-ig-detail__stat">' + ICONS.comment + ' ' + this.formatNumber(comments) + '</span>' +
          '</div>' +
          (post.caption ? '<p class="nds-ig-detail__caption">' + this.escapeHtml(post.caption) + '</p>' : '') +
          '<span class="nds-ig-detail__date">' + this.formatDate(post.timestamp) + '</span>' +
        '</div>';

      grid.style.display = 'none';
      if (profile) profile.style.display = 'none';
      detail.classList.add('is-active');
      this.igDetailActive = true;

      var self = this;
      detail.querySelector('.nds-ig-detail__back').addEventListener('click', function () {
        self.igShowGrid();
      });
    },

    /* — IG back to grid — */
    igShowGrid: function () {
      var modal = document.getElementById('nds-social-modal-instagram');
      if (!modal) return;
      var detail = modal.querySelector('#nds-ig-detail');
      var grid = modal.querySelector('#nds-ig-grid');
      var profile = modal.querySelector('.nds-ig-profile');
      if (detail) { detail.classList.remove('is-active'); detail.innerHTML = ''; }
      if (grid) grid.style.display = '';
      if (profile) profile.style.display = '';
      this.igDetailActive = false;
    },

    /* ── Skeleton Rendering ── */
    renderSkeleton: function (platform) {
      if (platform === 'instagram') {
        return '<div class="nds-social-skeleton">' +
          '<div class="nds-social-skeleton__row" style="padding:0 16px">' +
            '<div class="nds-social-skeleton__circle" style="width:56px;height:56px"></div>' +
            '<div style="flex:1;display:flex;flex-direction:column;gap:6px">' +
              '<div class="nds-social-skeleton__line nds-social-skeleton__line--medium"></div>' +
              '<div class="nds-social-skeleton__line nds-social-skeleton__line--short"></div>' +
            '</div>' +
          '</div>' +
          '<div class="nds-social-skeleton__grid">' +
            '<div class="nds-social-skeleton__square"></div>'.repeat(9) +
          '</div>' +
        '</div>';
      }
      /* facebook */
      var cards = '';
      for (var i = 0; i < 3; i++) {
        cards += '<div class="nds-social-skeleton__card">' +
          '<div class="nds-social-skeleton__row">' +
            '<div class="nds-social-skeleton__circle"></div>' +
            '<div style="flex:1;display:flex;flex-direction:column;gap:4px">' +
              '<div class="nds-social-skeleton__line nds-social-skeleton__line--medium"></div>' +
              '<div class="nds-social-skeleton__line nds-social-skeleton__line--short"></div>' +
            '</div>' +
          '</div>' +
          '<div class="nds-social-skeleton__rect"></div>' +
          '<div class="nds-social-skeleton__line nds-social-skeleton__line--full"></div>' +
          '<div class="nds-social-skeleton__line nds-social-skeleton__line--medium"></div>' +
        '</div>';
      }
      return '<div class="nds-social-skeleton">' + cards + '</div>';
    },

    /* ── Empty / Error State ── */
    renderEmpty: function (message, showRetry, platform) {
      return '<div class="nds-social-empty">' +
        '<div class="nds-social-empty__icon">' + ICONS.alertCircle + '</div>' +
        '<p class="nds-social-empty__text">' + this.escapeHtml(message) + '</p>' +
        (showRetry ? '<button class="nds-social-empty__retry" type="button">Try again</button>' : '') +
      '</div>';
    },

    /* ── Lazy Load Images ── */
    lazyLoadImages: function (container) {
      var images = container.querySelectorAll('img[data-src]');
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var img = entry.target;
              img.src = img.getAttribute('data-src');
              img.onload = function () { img.setAttribute('data-loaded', 'true'); };
              img.onerror = function () { img.setAttribute('data-loaded', 'true'); };
              observer.unobserve(img);
            }
          });
        }, { rootMargin: '100px' });
        images.forEach(function (img) { observer.observe(img); });
      } else {
        images.forEach(function (img) {
          img.src = img.getAttribute('data-src');
          img.onload = function () { img.setAttribute('data-loaded', 'true'); };
        });
      }
    },

    /* ── Utilities ── */
    formatDate: function (dateStr) {
      if (!dateStr) return '';
      try {
        var d = new Date(dateStr);
        var now = new Date();
        var diff = Math.floor((now - d) / 1000);
        if (diff < 60) return 'Just now';
        if (diff < 3600) return Math.floor(diff / 60) + 'm ago';
        if (diff < 86400) return Math.floor(diff / 3600) + 'h ago';
        if (diff < 604800) return Math.floor(diff / 86400) + 'd ago';
        return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      } catch (e) { return ''; }
    },

    formatNumber: function (n) {
      if (n == null) return '0';
      n = parseInt(n, 10);
      if (n >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
      if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
      return n.toString();
    },

    escapeHtml: function (str) {
      if (!str) return '';
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    },

    escapeAttr: function (str) {
      if (!str) return '';
      return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },

    /* ── Staggered entrance animation ── */
    staggerEntrance: function (elements, delayMs) {
      if (!elements || !elements.length) return;
      var delay = delayMs || 60;
      for (var i = 0; i < elements.length; i++) {
        (function (el, idx) {
          el.style.animationDelay = (idx * delay) + 'ms';
          el.classList.add('nds-social-post-enter');
        })(elements[i], i);
      }
    }
  };

  /* ── Auto-init ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { NDSSocialFeed.init(); });
  } else {
    NDSSocialFeed.init();
  }

  /* — Re-sync after Shopify theme editor re-renders a section —
     Global click delegation already handles new trigger buttons; we just
     refresh the API URL and (re)bind backdrop / close listeners on any
     freshly rendered modals. */
  document.addEventListener('shopify:section:load', function () {
    NDSSocialFeed.refreshApiBase();
    NDSSocialFeed.bindModalEvents();
  });

  /* expose for external use */
  window.NDSSocialFeed = NDSSocialFeed;
})();
